<template>
  <div class="container-fluid">

    <!-- ─── STEP 1 : ค้นหาพนักงาน ─────────────────────────────────── -->
    <template v-if="step === 'search'">
      <div class="row mb-5">
        <div class="col-12">
          <div class="card h-100 mt-2">
            <div class="card-header mb-0">
              <div class="d-flex align-items-center gap-2 mb-1">
                <i class="material-icons material-symbols-outlined text-success" style="font-size:22px">calendar_month</i>
                <h5 class="mb-0">ตารางวันทำงาน</h5>
              </div>
              <p class="text-sm text-secondary mb-0">ค้นหาพนักงาน แล้วกดเลือกเพื่อกำหนดตารางวันทำงาน</p>
            </div>
            <div class="card-body pt-0">

              <!-- Filter row -->
              <div class="row">
                <div class="col-lg-3">
                  <label class="form-label ms-0">รหัสพนักงาน</label>
                  <input v-model="empNumFilter" type="text" class="form-control"
                         placeholder="Employee Number" @keyup.enter="doSearch" />
                </div>
                <!-- <div class="col-lg-3">
                  <label class="form-label ms-0">ชื่อพนักงาน</label>
                  <input v-model="nameFilter" type="text" class="form-control"
                         placeholder="ชื่อ-สกุล" @keyup.enter="doSearch" />
                </div> -->
                <div class="col-lg-2">
                  <label class="form-label ms-0 png"></label>
                  <button type="button" class="btn bg-gradient-success mb-0 float-lg-start float-sm-end" @click="doSearch">
                    <i class="material-icons material-symbols-outlined me-1" style="font-size:16px;vertical-align:middle">search</i>
                    ค้นหา
                  </button>
                </div>
              </div>

              <!-- User table -->
              <div class="row mt-3">
                <div class="table-responsive">
                  <table class="table table-flush">
                    <thead class="thead-light">
                      <tr>
                        <th>#</th>
                        <th>รหัสพนักงาน</th>
                        <th>ชื่อ-สกุล</th>
                        <th>อีเมล</th>
                        <th>จัดการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loading">
                        <td colspan="5" class="text-center py-4">
                          <div class="spinner-border spinner-border-sm text-success" role="status"></div>
                          <span class="ms-2 text-secondary">กำลังโหลด...</span>
                        </td>
                      </tr>
                      <tr v-else-if="listdata.length === 0">
                        <td colspan="5" class="text-center text-secondary py-4">ไม่พบพนักงานที่ค้นหา</td>
                      </tr>
                      <tr v-for="(u, i) in listdata" v-else :key="u.uid">
                        <td class="text-sm font-weight-normal align-middle">  {{ formatNumberString((currentPage - 1) * perPage + i + 1) }}</td>
                        <td class="text-sm font-weight-normal align-middle font-monospace">{{ u.employeeNumber }}</td>
                        <td class="text-sm font-weight-normal align-middle">{{ u.nameTh }}</td>
                        <td class="text-sm font-weight-normal align-middle">{{ u.email }}</td>
                        <td class="text-sm align-middle">
                          <button type="button"
                                  class="btn btn-outline-success btn-sm rounded-circle mb-0"
                                  style="width:34px;height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center"
                                  title="กำหนดตารางวันทำงาน"
                                  @click="pickUser(u)" :disabled="isDisabledUser(u)">
                            <i class="material-icons material-symbols-outlined" style="font-size:17px">calendar_month</i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot v-if="totalRows > 0">
                      <tr>
                        <td colspan="5" style="text-align:right">Total Rows : {{ totalRows }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>

              <!-- Pagination -->
              <div v-if="listdata.length > 0" style="display:flex; justify-content:flex-end">
                <ul class="pagination justify-content-end">
                  <div class="project-container">
                    <div class="example-one">
                      <vue-awesome-paginate v-model="currentPage"
                        :total-items="totalRows" :items-per-page="perPage"
                        @click="onClickHandler" />
                    </div>
                  </div>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- ─── STEP 2 : กำหนดตารางวันทำงาน ────────────────────────────── -->
    <template v-else>
      <div class="row mb-5">
        <div class="col-12">
          <div class="card h-100 mt-2">

            <!-- Card header -->
            <div class="card-header mb-0">
              <div>
                <div class="d-flex align-items-center gap-2">
                  <i class="material-icons material-symbols-outlined text-success" style="font-size:22px">calendar_month</i>
                  <h5 class="mb-0">ตารางวันทำงาน</h5>
                </div>
                <p class="text-sm text-secondary mb-0 mt-1">
                  กำหนดสาขาในแต่ละวันสำหรับ
                  <strong>{{ selectedUser.nameTh }}</strong>
                  — แต่ละวันเลือกได้ 1 สาขา (เลือกซ้ำได้)
                </p>
              </div>

              <!-- Authorized shops pills -->
              <div class="d-flex align-items-center gap-2 mt-3 flex-wrap" v-if="authorizedShops.length">
                <span class="text-xs fw-semibold text-secondary">สาขาที่มีสิทธิ์:</span>
                <span v-for="s in authorizedShops" :key="s.uid"
                      class="badge border fw-normal px-2 py-1"
                      style="font-size:11px; background:#fff; color:#495057; border-color:#dee2e6 !important">
                  <span class="rounded-circle d-inline-block me-1"
                        :style="{ background: shopColor(s.uid), width:'7px', height:'7px' }"></span>
                  {{ s.nameTh }}
                </span>
              </div>
            </div>

            <!-- Card body — 7-day grid -->
            <div class="card-body pt-3" style="overflow:visible">
              <div class="schedule-grid" style="position:relative">
                <div v-for="(day, idx) in WEEK" :key="day"
                     class="schedule-col"
                     style="position:relative">

                  <!-- Day header -->
                  <div class="schedule-day-hd d-flex align-items-center justify-content-between px-2 py-2 border-bottom">
                    <span class="fw-bold text-sm">{{ day }}</span>
                    <i v-if="shopForDay(idx)" class="material-icons text-success" style="font-size:16px">check_circle</i>
                  </div>

                  <!-- Day body -->
                  <div class="schedule-day-body p-2 d-flex flex-column gap-2">

                    <!-- Shop assigned -->
                    <template v-if="shopForDay(idx)">
                      <div class="schedule-chip d-flex flex-column gap-1 p-2 rounded"
                           :style="{ background: shopBg(shopForDay(idx).uid),
                                     borderLeft: `3px solid ${shopColor(shopForDay(idx).uid)}`,
                                     border: `1px solid ${shopBorder(shopForDay(idx).uid)}`,
                                     borderLeftWidth: '3px' }">
                        <div class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center gap-1">
                            <i class="material-icons" :style="{ color: shopColor(shopForDay(idx).uid), fontSize:'14px' }">store</i>
                            <span class="fw-semibold text-truncate" style="font-size:12px"
                                  :style="{ color: shopColor(shopForDay(idx).uid) }">
                              {{ shopForDay(idx).nameTh }}
                            </span>
                          </div>
                          <button class="btn-close-sm" @click="removeShop(idx)" title="ลบ">
                            <i class="material-icons" style="font-size:13px; color:#adb5bd">close</i>
                          </button>
                        </div>
                        <div class="font-monospace" style="font-size:10px; color:#6c757d">{{ shopForDay(idx).code }}</div>
                      </div>
                    </template>

                    <!-- Empty — add button -->
                    <template v-else>
                      <button class="schedule-add-btn flex-grow-1 d-flex flex-column align-items-center justify-content-center gap-1 rounded border-0"
                              :class="openPicker === idx ? 'schedule-add-btn--active' : ''"
                              @click.stop="togglePicker(idx, $event)">
                        <i class="material-icons text-secondary" style="font-size:20px">add_circle_outline</i>
                        <span style="font-size:11px">เพิ่มสาขา</span>
                      </button>

                      <!-- Popover -->
                      <div v-if="openPicker === idx"
                           class="schedule-pop card shadow"
                           :style="pickerStyle()"
                           @click.stop>
                        <div class="card-header py-2 px-3">
                          <div class="text-sm fw-semibold mb-2">เลือกสาขาวัน{{ day }}</div>
                          <!-- Search input -->
                          <div class="input-group input-group-sm">
                            <span class="input-group-text bg-white border-end-0 pe-1">
                              <i class="material-icons" style="font-size:15px;color:#adb5bd">search</i>
                            </span>
                            <input v-model="pickerSearch"
                                   type="text"
                                   class="form-control border-start-0 ps-1"
                                   placeholder="พิมพ์ชื่อหรือรหัสสาขา…"
                                   style="font-size:12px"
                                   @click.stop />
                          </div>
                        </div>
                        <div class="list-group list-group-flush schedule-pop-list">
                          <button v-for="s in filteredPickerShops" :key="s.uid"
                                  class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2 px-3 border-0"
                                  style="font-size:13px"
                                  @click.stop="assignShop(idx, s.uid)">
                            <span class="rounded d-flex align-items-center justify-content-center"
                                  :style="{ background: shopBg(s.uid), width:'28px', height:'28px' }">
                              <i class="material-icons" :style="{ color: shopColor(s.uid), fontSize:'15px' }">store</i>
                            </span>
                            <div class="flex-grow-1 text-start">
                              <div class="fw-semibold" style="font-size:12px">{{ s.nameTh }}</div>
                              <div class="font-monospace text-secondary" style="font-size:10px">{{ s.code }}</div>
                            </div>
                            <i class="material-icons text-success" style="font-size:16px">add</i>
                          </button>
                          <div v-if="filteredPickerShops.length === 0"
                               class="list-group-item text-secondary text-center py-3" style="font-size:12px">
                            ไม่พบสาขาที่ค้นหา
                          </div>
                        </div>
                      </div>
                    </template>

                  </div>
                </div>
              </div>

              <!-- Footer -->
              <div class="d-flex align-items-center gap-2 mt-3 text-secondary" style="font-size:12px">
                <i class="material-icons" style="font-size:15px">info</i>
                กำหนดแล้ว {{ assignedCount }} จาก 7 วัน · แต่ละวันเลือกได้ 1 สาขา สาขาเดียวกันสามารถกำหนดซ้ำได้
              </div>

              <!-- Actions -->
              <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
                <button type="button" class="btn bg-gradient-danger mb-0" @click="backToSearch">
                  <i class="material-icons material-symbols-outlined me-1" style="font-size:16px;vertical-align:middle">close</i>
                  ยกเลิก
                </button>
                <button type="button" class="btn bg-gradient-success mb-0" @click="saveSchedule" :disabled="saving">
                  <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  <i v-else class="material-icons material-symbols-outlined me-1" style="font-size:16px;vertical-align:middle">save</i>
                  {{ saving ? 'กำลังบันทึก...' : 'บันทึก' }}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </template>

    <!-- Overlay to close picker -->
    <div v-if="openPicker !== null"
         style="position:fixed; inset:0; z-index:9998"
         @click="openPicker = null; pickerRect = null" />

  </div>
</template>

<script setup>
import { ref, computed, onMounted, inject } from 'vue'
import { useRoute } from 'vue-router'
import { useSecUsersStore }     from '@/stores/secusers'
import { useSecUsersRoleStore } from '@/stores/secusersrole'

const route       = useRoute()
const storesec_u  = useSecUsersStore()
const storesec_ur = useSecUsersRoleStore()
const swal        = inject('$swal')

// ─── Shop data from localStorage ────────────────────────────────────────────
const shopList = ref([])

onMounted(async () => {
  const raw = localStorage.getItem('shoplist')
  if (raw) {
    try { shopList.value = JSON.parse(raw) } catch (e) { console.warn('shoplist parse error', e) }
  }
  // ถ้ามาจาก UserManagement ด้วย ?uid= ให้ดึงข้อมูล user แล้วข้าม step ค้นหา
  if (route.query.uid) {
    await loadUserByUid(route.query.uid)
  }
  // ไม่ auto-load — ต้องกดปุ่มค้นหาเท่านั้น
})

// ─── Shop colors (Golden Ratio — รองรับ 50+ สาขา) ───────────────────────────
const GOLDEN_ANGLE = 137.508
const shopColor  = (uid) => {
  const idx = shopList.value.findIndex(s => s.uid === uid)
  const i   = idx < 0 ? 0 : idx
  const hue = (i * GOLDEN_ANGLE) % 360
  const L   = i % 2 === 0 ? 0.50 : 0.54
  return `oklch(${L} 0.13 ${hue.toFixed(1)})`
}
const shopBg     = (uid) => `color-mix(in oklch, ${shopColor(uid)} 13%, white)`
const shopBorder = (uid) => `color-mix(in oklch, ${shopColor(uid)} 35%, white)`

// ─── State ───────────────────────────────────────────────────────────────────
const listdata     = ref([])
const loading      = ref(false)
const currentPage  = ref(1)
const perPage      = ref(30)
const totalRows    = ref(0)

const empNumFilter = ref('')
const openPicker   = ref(null)
const pickerSearch = ref('')
const pickerRect   = ref(null)
const assignments  = ref({})

const step         = ref('search')
const selectedUser = ref(null)

const WEEK = ['จันทร์','อังคาร','พุธ','พฤหัสบดี','ศุกร์','เสาร์','อาทิตย์']

const DAY_ENG = ['MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY','SUNDAY']
const DAY_ENG_TO_IDX = Object.fromEntries(DAY_ENG.map((d, i) => [d, i]))

// ─── API calls ────────────────────────────────────────────────────────────────
async function loadDataApi() {
  // loading.value = true
  try {
    const response = await storesec_u.usersListFetch({
      index: currentPage.value - 1,
      size:  perPage.value,
      employeeNumber: empNumFilter.value.trim(),
    })
    if (response?.status === 200 && response.data.rtnDesc === 'success') {
      listdata.value  = response.data.data.list
      totalRows.value = response.data.data.ext.total
    }
  } catch (e) {
    console.error('loadDataApi error', e)
  } finally {
    // loading.value = false
  }
}

async function loadUserByUid(uid) {
  try {
    // 1. ดึงข้อมูล user (ชื่อ, รหัส)
    const userRes = await storesec_u.usersInfoFetch({ uid })
    if (userRes?.status !== 200 || userRes.data.rtnDesc !== 'success') return
    selectedUser.value = userRes.data.data

    // 2. ดึง role list พร้อม workHours ของ user
    const roleRes = await storesec_ur.usersRoleListFetch({
      index: 0, size: 100,
      userLevel: '', shopUid: '', userUid: uid, businessRole: '',
    })
    
    if (roleRes?.status === 200 && roleRes.data.rtnDesc === 'success') {
      const roles = roleRes.data.data.list

      // ✨ เพิ่มเงื่อนไขเช็คว่าถ้า list ว่างเปล่า
      if (!roles || roles.length === 0) {
        step.value = 'search'
        swal("ไม่พบข้อมูลการมอบหมายสาขา", "", "warning");
        return // ออกจากฟังก์ชันทันที ไม่ต้องทำขั้นตอนถัดไป
      }

      selectedUser.value = { ...selectedUser.value, shops: roles }

      // 3. Restore assignments จาก workHours (array of { dayOfWeek }) ที่เคยบันทึกไว้
      const restored = {}
      roles.forEach(role => {
        const hours = role.workHours ?? []
        hours.forEach(h => {
          const idx = DAY_ENG_TO_IDX[h.dayOfWeek]
          if (idx !== undefined) restored[idx] = role.shopUid
        })
      })
      assignments.value = restored
    }
    step.value = 'schedule'
  } catch (e) {
    console.error('loadUserByUid error', e)
  }
}

function doSearch() {
  currentPage.value = 1
  loadDataApi()
}

function onClickHandler() {
  loadDataApi()
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

const isDisabledUser = (row) => {
  return row?.userLevel === 'admin' || row?.email?.includes('platform') || row?.email?.includes('@novatecx.com');
};

// ─── Computed ─────────────────────────────────────────────────────────────────
const authorizedShops = computed(() => {
  const userShops = selectedUser.value?.shops
  if (!userShops?.length) return []
  const allowed = new Set(userShops.map(s => s.shopUid))
  return shopList.value.filter(s => allowed.has(s.uid))
})

const filteredPickerShops = computed(() => {
  const q = pickerSearch.value.trim().toLowerCase()
  if (!q) return authorizedShops.value
  return authorizedShops.value.filter(s =>
    s.nameTh?.toLowerCase().includes(q) ||
    s.code?.toLowerCase().includes(q)
  )
})

const assignedCount = computed(() =>
  Object.values(assignments.value).filter(Boolean).length
)

// ─── Actions ──────────────────────────────────────────────────────────────────
async function pickUser(user) {
  assignments.value = {}
  openPicker.value  = null
  // list API ไม่ return shops — ต้องดึง info เพื่อให้ได้ shops ครบ
  await loadUserByUid(user.uid)
}

function backToSearch() {
  step.value         = 'search'
  selectedUser.value = null
  assignments.value  = {}
}

function togglePicker(idx, event) {
  if (openPicker.value === idx) {
    openPicker.value = null
    pickerRect.value = null
  } else {
    openPicker.value = idx
    pickerSearch.value = ''
    const btn = event?.currentTarget
    if (btn) pickerRect.value = btn.getBoundingClientRect()
  }
}

function pickerStyle() {
  if (!pickerRect.value) return 'position:fixed; top:200px; left:50%; transform:translateX(-50%)'
  const r = pickerRect.value
  const left = Math.min(r.left + r.width / 2 - 130, window.innerWidth - 275)
  return `position:fixed; top:${r.bottom + 6}px; left:${Math.max(10, left)}px; z-index:9999`
}

function assignShop(dayIdx, shopUid) {
  assignments.value = { ...assignments.value, [dayIdx]: shopUid }
  openPicker.value  = null
}

function removeShop(dayIdx) {
  const next = { ...assignments.value }
  delete next[dayIdx]
  assignments.value = next
}

function shopForDay(idx) {
  const uid = assignments.value[idx]
  return uid ? shopList.value.find(s => s.uid === uid) : null
}

const saving = ref(false)

async function saveSchedule() {
  const roles = selectedUser.value?.shops
  if (!roles?.length) return

  // จัดกลุ่ม dayOfWeek ตาม shopUid จาก assignments
  const shopDays = {}
  Object.entries(assignments.value).forEach(([dayIdx, shopUid]) => {
    if (!shopUid) return
    if (!shopDays[shopUid]) shopDays[shopUid] = []
    shopDays[shopUid].push(DAY_ENG[dayIdx])
  })

  saving.value = true
  try {
    const promises = roles.map(role => {
      const days = shopDays[role.shopUid] ?? []
      return storesec_ur.usersRoleUpdateFetch({
        uid:          role.uid,
        groupUid:     role.groupUid,
        shopUid:      role.shopUid,
        userUid:      role.userUid,
        userLevel:    role.userLevel,
        businessRole: role.businessRole,
        workHours:    days.map(d => ({ dayOfWeek: d, startTime: '00:00', endTime: '23:59' })),
        version:      role.version,
      })
    })

    const results = await Promise.all(promises)
    const allOk = results.every(r => r?.status === 200 && r.data.rtnDesc === 'success')

    if (allOk) {
      await swal('บันทึกสำเร็จ', '', 'success')
      backToSearch()
    } else {
      swal('บันทึกบางรายการไม่สำเร็จ', 'กรุณาลองใหม่อีกครั้ง', 'error')
    }
  } catch (e) {
    console.error('saveSchedule error', e)
    swal('เกิดข้อผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error')
  } finally {
    saving.value = false
  }
}

</script>

<style scoped>
.schedule-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
}
.schedule-col {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.schedule-day-hd {
  background: #f8f9fa;
  min-height: 44px;
}
.schedule-day-body {
  min-height: 110px;
  flex: 1;
}
.schedule-chip {
  border-radius: 6px;
}
.schedule-add-btn {
  min-height: 90px;
  background: transparent;
  border: 1.5px dashed #ced4da !important;
  color: #adb5bd;
  cursor: pointer;
  font-family: inherit;
  transition: border-color .15s, color .15s, background .15s;
  width: 100%;
}
.schedule-add-btn:hover { border-color: #66bb6a !important; color: #43a047; }
.schedule-add-btn--active { border-style: solid !important; border-color: #66bb6a !important; color: #43a047; background: #f1f8e9; }
.schedule-pop {
  width: 260px;
  border-radius: 10px;
  overflow: hidden;
}
.schedule-pop-list {
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
}
.btn-close-sm {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
}
.btn-close-sm:hover i { color: #dc3545 !important; }
.user-row-hover:hover { background-color: rgba(102, 187, 106, 0.05); }
</style>
